module.exports = __webpack_public_path__ + "img/address.f454a33e.png";